module.exports = __webpack_public_path__ + "static/media/1002264.a8c5d827.png";